import { NotificationType } from 'angular2-notifications';
import { PushNotificationData } from './push-notification-model';

export class NotificationToast {
  title?: string;
  body?: string;
  image?: string;
  NotificationType?: NotificationType;
  data?: PushNotificationData;
}
